module.exports = __webpack_public_path__ + "media/images/flags/16/Maldives-c90f8949ee789eca679b8e25e4a0a124.png";